import FormsyInput from 'shared/components/Textfield'
import ToggleSwitch from 'shared/components/ToggleSwitch'
import imgSurveyModal from 'shared/assets/NPS-illustration-survey.png'
import imgThankYouModal from 'shared/assets/NPS-Illustration-thankyou.png'

import ThankYouModalContent from './ThankYouModalContent'
import styles from '../styles.module.scss'

const FieldsList = ({
    isToggled,
    setIsToggled,
    translationType,
    onChange,
    prefix,
    formData,
    setShowError,
    onChangeHandlerTextarea,
}) => (
    <>
        <h2 className="text-center">
            <T values={{ translationType: translationType }}>nps.admin.create.new.survey.form.title</T>
        </h2>
        <div className={styles.npsTextSection}>
            <div className={styles.textContent}>
                <div className="d-flex flex-column">
                    <span className="text-large">
                        <T>nps.admin.create.new.survey.name.title</T>
                    </span>
                    <FormsyInput
                        required
                        name={`${prefix}titleText`}
                        onChange={onChange}
                        value={formData[`${prefix}titleText`] || ''}
                        setShowError={setShowError}
                    />
                </div>
                <div className="d-flex flex-column ">
                    <span className="text-large">
                        <T>nps.admin.create.new.survey.question.title</T>
                    </span>
                    <FormsyInput
                        required
                        name={`${prefix}ratingText`}
                        onChange={onChange}
                        value={formData[`${prefix}ratingText`] || ''}
                        setShowError={setShowError}
                    />
                </div>
                <div className="d-flex flex-column">
                    <span className="text-large">
                        <T>nps.admin.create.new.survey.scale.title</T>
                    </span>
                    <FormsyInput
                        required
                        name={`${prefix}ratingExplanation`}
                        onChange={onChange}
                        value={formData[`${prefix}ratingExplanation`] || ''}
                        setShowError={setShowError}
                    />
                </div>
                <div className="d-flex flex-row justify-content-between">
                    <span className="text-large">
                        <T>nps.admin.create.new.survey.toggle.title</T>
                    </span>
                    <ToggleSwitch
                        id={1}
                        label="label"
                        name={`${prefix}textResponseRequired`}
                        checked={isToggled}
                        onChange={() => setIsToggled(prefix)}
                    />
                </div>
                {isToggled && (
                    <>
                        <div className="d-flex flex-column">
                            <span className="text-large">
                                <T>nps.admin.create.new.survey.feedback.question.title</T>
                            </span>
                            <FormsyInput
                                name={`${prefix}questionText`}
                                onChange={onChange}
                                value={formData[`${prefix}questionText`] || ''}
                                required
                                setShowError={setShowError}
                            />
                        </div>
                        <div className="d-flex flex-column">
                            <span className="text-large">
                                <T>nps.admin.create.new.survey.feedback.desc.title</T>
                            </span>
                            <FormsyInput
                                name={`${prefix}questionHint`}
                                onChange={onChange}
                                value={formData[`${prefix}questionHint`] || ''}
                                required
                                setShowError={setShowError}
                            />
                        </div>
                    </>
                )}
            </div>
            <div className={styles.imgSurveyWrap}>
                <img src={imgSurveyModal} alt="Survey modal example" />
            </div>
        </div>
        <ThankYouModalContent
            translationType={translationType}
            imgUrl={imgThankYouModal}
            prefix={prefix}
            onChange={onChange}
            formData={formData}
            setShowError={setShowError}
            onChangeHandlerTextarea={onChangeHandlerTextarea}
        />
    </>
)

export default FieldsList
